/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsEntityTypeForApplicationChange extends models.AppSecopsEntityType {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsEntityTypeForApplicationChange");
    }

    getFixupPrototypeFunction() { return AppSecopsEntityTypeForApplicationChange.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsEntityTypeForApplicationChange>): AppSecopsEntityTypeForApplicationChange {
        let obj = Object.assign(new AppSecopsEntityTypeForApplicationChange(), model);
        AppSecopsEntityTypeForApplicationChange.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsEntityTypeForApplicationChange>): AppSecopsEntityTypeForApplicationChange {
        if (!model) return null;
        return AppSecopsEntityTypeForApplicationChange.newInstance(<AppSecopsEntityTypeForApplicationChange> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsEntityTypeForApplicationChange) {
        if (!obj) return;

        models.AppSecopsEntityTypeForApplicationChange.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsEntityTypeForApplicationChange): boolean {
        if (models.AppSecopsEntityType.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsEntityTypeForApplicationChange.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
